import { render, staticRenderFns } from "./ReferencesEditPortal.vue?vue&type=template&id=990565e8&"
import script from "./ReferencesEditPortal.vue?vue&type=script&lang=js&"
export * from "./ReferencesEditPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports